import {FILE_TYPE} from './const';
import URL from '../../config/url';
import {DataPreparationOrigin} from '../../types/dataset/DataPreparationContainer';

export function getOriginUrl(origin: DataPreparationOrigin) {
  return origin === 'deployment'
    ? URL.DATASET_DEPLOYMENT
    : origin === 'dataset'
    ? URL.DATASET_DATASET
    : URL.DATASET_RAW;
}

export const BINARY_TO_LOCAL_TYPE = {
  'binary/image': FILE_TYPE.IMAGE,
  'binary/video': FILE_TYPE.VIDEO,
};

export const LOCAL_TYPE_TO_BINARY = {
  image: 'binary/image',
  video: 'binary/video',
};

export const localTypeToBinary = (type: string) => {
  switch (type) {
    case 'image':
      return 'binary/image';
    case 'video':
      return 'binary/video';
    default:
      return 'binary/file';
  }
};
